angular.module('zc.projects')

.directive 'zcItemListPriceEditor', (ProjectItemListPrice, Meta, BaseProjectCrudEditor) ->

  class ItemListPriceEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality

  editor = new ItemListPriceEditor(
    ProjectItemListPrice
    Meta
    '/templates/projects.settings/initialization/item_list_price_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/item_list_price_editor.directive.coffee